import axios from "axios";

export const getSurvery = async () => {
  try {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let response = { data: {} };
    if (params.get("data")) {
      response.data = JSON.parse(params.get("data"));
    } else if (params.get("src")) {
      response = await axios.get(params.get("src"));
    }

    if (
      typeof response.data.questionsToShuffle !== "undefined" &&
      response.data.questionsToShuffle.length > 0
    ) {
      const indexesToShuffele = getShuffleIndexes(
        response.data.screens,
        response.data.questionsToShuffle
      );
      const shuffledIndexes = shuffleIndexes(indexesToShuffele);

      shuffleQuestionsArray(shuffledIndexes, response.data.screens);
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

function getShuffleIndexes(questionsArray, screenKeysToShuffle) {
  const indexes = [];
  const questionsArrayLength = questionsArray.length;

  for (let index = 0; index < questionsArrayLength; index++) {
    const question = questionsArray[index];
    if (screenKeysToShuffle.indexOf(question.screenKey) !== -1)
      indexes.push(index);
  }

  return indexes;
}

function shuffleIndexes(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

function shuffleQuestionsArray(indexesToShuffle, questions) {
  for (let index = 0; index < indexesToShuffle.length; index++) {
    const j = indexesToShuffle[index];
    if (indexesToShuffle.indexOf(index) !== -1) {
      const temp = questions[index];
      questions[index] = questions[j];
      questions[j] = temp;
      indexesToShuffle.splice(index, 1);
    }
  }
}
